/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-get */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class SchoolOptionsRoute extends Route {
  @service
  session;

  @service
  options;

  @service
  router;

  model() {
    let schoolId = this.get('session.activeSchool');
    return this.options.load(schoolId);
  }

  init() {
    super.init(...arguments);

    this.router.on('routeWillChange', (transition) => {
      if (
        isEmpty(transition.from) ||
        !transition.from.find((route) => route.name === this.routeName)
      ) {
        return;
      }
      if (!transition.to.find((route) => route.name === this.routeName)) {
        let school = this.get('session.school');

        if (school.get('currentState.isDirty')) {
          if (
            window.confirm(
              'You have unsaved changes which will be lost if you leave this page.  Are you sure you wish to leave?',
            )
          ) {
            school.rollbackAttributes();
          } else {
            transition.abort();
          }
        }
      }
    });
  }
}
